// extracted by mini-css-extract-plugin
export default {"container":"OverflowMenu_container__zXa2p","hidden":"OverflowMenu_hidden__8IJF9"};